window.Vue = require('vue')
import $ from 'jquery'
import {ModelListSelect} from 'vue-search-select'

Vue.component('search-select', ModelListSelect)

window.$ = window.jQuery = $
require('bootstrap')
